import React, { ElementType } from 'react';
import PropTypes, { InferProps } from 'prop-types';
import s from './Heading.module.scss';

/** Renders headings from level 1 - 6 */
function Heading({
  level,
  htmlLevel,
  className,
  children,
}: InferProps<typeof Heading.propTypes>) {
  const HeadingTag: ElementType = htmlLevel
    ? (`h${htmlLevel}` as ElementType)
    : (`h${level}` as ElementType);
  const levelClass = `level-${level}`;
  return (
    <HeadingTag className={`${s.heading} ${s[levelClass]} ${className}`}>
      {children}
    </HeadingTag>
  );
}
Heading.defaultProps = {
  className: '',
  htmlLevel: null,
};

Heading.propTypes = {
  /** Heading level, e.g. 1 for <h1> */
  level: PropTypes.oneOf([1, 2, 3, 4, 5, 6]).isRequired,
  /** If the html tag needs to be a different heading level than the appearance,
   * use this prop to set the html element's level. This might be needed to e.g. assure
   * there is an h1 on each page for accessibility.
   */
  htmlLevel: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  /** Class name to pass to the heading tag */
  className: PropTypes.string,
  /** Heading text */
  children: PropTypes.node.isRequired,
};

export default Heading;
